import React from 'react'
import colors from '../../utils/colors'

const Radio = ({name, id, label, onChange, className, form, disabled, value}) => {
  const [checked, setChecked] = React.useState(false)

  React.useEffect(() => {
    if(form && form[name]){
      if(form[name] === value){
        setChecked(true)
      } else {
        setChecked(false)
      }
    }
  }, [form, name, value])

  const handleChange = (e) => {
    console.log(e)
    setChecked(e.target.value)
    if(typeof onChange === 'function'){
      onChange({
        target: {
          name,
          value
        }
      })
    }
  }

  const outStyle = {
    width: '20px',
    height: '20px',
    borderColor: '#ddd',
  }

  const innerStyle = {
    width: '12px',
    height: '12px',
    background: checked ? colors.green : '#fff'
  }

  return (
    <label className={`cursor-pointer flex lg:items-center ${className}`} htmlFor={id}>
      <div>
        <input type="radio" name={name} value={value} id={id} className="hidden" defaultChecked={checked} onChange={handleChange} disabled={disabled}/>
        <div style={outStyle} className="rounded-full mr-2 border flex justify-center items-center">
          <div style={innerStyle} className="rounded-full"></div>
        </div>
      </div>
      <div className="leading-none lg:leading-normal">
        <span
          className={`leading-none lg:leading-normal text-sm text-gray-444 ${disabled || !checked ? 'opacity-50' : ''}`}
        >
          {label}
        </span>
      </div>
    </label>
  )
}

export { Radio }
